import React from 'react';

/* Sub Heading*/
const SubHeading = ({ subHeading, classes='' }) => {
  return <p className={'max-w-4xl mb-0 text-gray-500 ' + (classes ? classes:'text-sm') }>{subHeading}</p>;
};

export default SubHeading;
